module.exports = __webpack_public_path__ + "img/logo.b7e3d87c.svg";